import { QRCodeSVG } from "qrcode.react";

const Field = ({ k, v, size = "12pt", mono = false }) => (
  <div style={{ minWidth: 0 }}>
    <div className="lbl">{k}</div>
    <div
      className={`val${mono ? " font-mono-data" : ""}`}
      style={{ fontSize: size }}
    >
      {v}
    </div>
  </div>
);

export const PieceLabel = ({ slab, piece, forwardRef }) => {
  const url = `${window.location.origin}/inventory/slabs/${slab.id}?piece=${piece.id}`;
  const sqft = Math.round(((piece.length_in * piece.width_in) / 144) * 10) / 10;
  const notes = [piece.source, piece.notes].filter(Boolean).join(" · ") || "—";

  return (
    <div
      className="label-4x6 print-label"
      ref={forwardRef}
      data-testid="piece-label-sheet"
    >
      <div className="lbl-head">
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: "8pt", fontWeight: 700, letterSpacing: "0.18em" }}>
            SLAB PIECE
          </div>
          <div className="font-mono-data" style={{ fontSize: "20pt", fontWeight: 700 }}>
            {piece.serial_number || slab.code}
          </div>
        </div>
        <div style={{ textAlign: "right", fontSize: "8pt", fontWeight: 700, flexShrink: 0 }}>
          <div style={{ border: "2px solid #000", padding: "2px 6px" }}>
            {(piece.status || "In Stock").toUpperCase()}
          </div>
          <div style={{ marginTop: 3 }}>{slab.code}</div>
        </div>
      </div>

      <div className="lbl-body">
        <Field k="Slab Color" v={slab.slab_color} size="17pt" />
        <Field k="Piece" v={piece.name || "—"} />
        <div className="lbl-grid">
          <Field k="Serial #" v={piece.serial_number || "—"} mono />
          <Field k="Lot #" v={piece.lot_number || "—"} mono />
          <Field k="Bundle #" v={piece.bundle_number || "—"} mono />
          <Field k="Rack" v={slab.location || "—"} />
        </div>
        <Field k="Supplier" v={slab.supplier || "—"} />
        <div className="lbl-row">
          <Field k="Size" v={`${piece.length_in}" x ${piece.width_in}"`} size="14pt" mono />
          <Field k="Thk" v={slab.thickness || "—"} size="14pt" mono />
          <Field k="Area" v={`${sqft} ft²`} size="14pt" mono />
        </div>
        <div style={{ borderTop: "1px solid #000", paddingTop: "0.04in" }}>
          <div className="lbl">Source / Notes</div>
          <div className="lbl-notes">{notes}</div>
        </div>
      </div>

      <div className="lbl-foot">
        <div style={{ fontSize: "7pt", color: "#333", maxWidth: "2.2in" }}>
          Scan to open this piece
          <div className="font-mono-data" style={{ fontSize: "6.5pt", wordBreak: "break-all" }}>
            {piece.id}
          </div>
        </div>
        <QRCodeSVG value={url} size={78} level="M" bgColor="#ffffff" fgColor="#000000" />
      </div>
    </div>
  );
};
